import { useState, useCallback } from 'react'

export function useSelectionMode() {
  const [isSelecting, setIsSelecting] = useState(false)
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set())

  const enter = useCallback(() => setIsSelecting(true), [])

  const clear = useCallback(() => {
    setIsSelecting(false)
    setSelectedIds(new Set())
  }, [])

  // 選択モードは維持したまま、選択中の項目だけ全解除する
  const deselectAll = useCallback(() => setSelectedIds(new Set()), [])

  const toggle = useCallback((id: number) => {
    setSelectedIds((prev) => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
  }, [])

  return {
    isSelecting,
    selectedIds: [...selectedIds],
    enter,
    clear,
    deselectAll,
    toggle,
  }
}
